import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable } from 'rxjs';
import { ResponseApiHelper } from 'src/app/helpers/response-api/response-api-helper';
import { HandleErrorService } from 'src/app/services/handle-error/handle-error.service';
import { CarbonModalService } from 'src/app/services/modal/carbon-modal.service';
import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';
import { CarbonCreditApproval } from 'src/app/shared/interfaces/carbon-credit-approval';
import { Pagination } from 'src/app/shared/interfaces/pagination';
import { PatchApi } from 'src/app/shared/interfaces/response-api';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { AppConfigService } from 'src/environments/app-config.service';

import { CarbonFilter } from '../../characteristic-consult/interfaces/carbon-filter';
import { RegisterService } from '../../services/register.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterConfirmationService extends ResponseApiHelper<CarbonCredit> {
  private readonly environment: any
  private apiUrl: string;

  filters: BehaviorSubject<CarbonFilter> = new BehaviorSubject<CarbonFilter>({});

  constructor(
    protected override readonly httpClient: HttpClient,
    private readonly carbonModalService: CarbonModalService,
    private readonly appConfig: AppConfigService,
    private readonly toastService: AppToastService,
    private readonly registerService: RegisterService,
    private readonly handleErrorService: HandleErrorService,
  ) {
    super(httpClient);

    this.environment = this.appConfig.config;
    this.apiUrl = this.environment.apiIssuer + '/instruments'
   }

  public getPendingApproval(filters: CarbonFilter, pagination: Pagination<CarbonCredit>): Observable<Pagination<CarbonCredit>> {
    const url = this.apiUrl + '/pending-approval-instruments'
    const params = this.registerService.carbonFilterParams(filters,pagination);

    return this.genericGet(url,'pendingApprovalInstruments', params, pagination).pipe(
      map((response) => {
        response.results = this.registerService.transformDataCarbonCredit(response.results);
        return response
      }),
      catchError((err) => {
            this.carbonModalService.openCarbonCreditGetListError();

            return this.handleErrorService.handleError(err)
      })
    )
  }

  setDrawerFilters(filters: CarbonFilter): void {
    this.filters.next(filters);
  }

  getDrawerFilters(): CarbonFilter {
    return this.filters.getValue();
  }

  getCarbonCreditById(code: string): Observable<CarbonCredit> {
    const url = `${this.apiUrl}/${code}`;

    return this.httpClient.get<{ data: CarbonCredit }>(url).pipe(
      map(response => this.registerService.transformCarbonCredit(response.data)),
      catchError(err => this.handleErrorService.handleError(err)),
    );
  }

  public carbonCreditApproval(
    carbonCreditApprove: CarbonCreditApproval[],
    options?: { showToast?: boolean },
  ): Observable<any> {
    const url = this.apiUrl
    const message = carbonCreditApprove[0]?.statusCode == 'APPROVED' ? 'aprovar' : 'rejeitar';
    const showToast = options?.showToast ?? true;

    const approval: PatchApi<CarbonCreditApproval> = {
      data: {
        requestInstruments: carbonCreditApprove
      }
    }

    return this.httpClient.patch(url, approval).pipe(
      map(data => {
        if (showToast) {
          this.toastService.show({
            status: 'success',
            text: `Sucesso ao ${message} credito de carbono`
          })
        }

        return data;
      }),
      catchError(err => {
          if (showToast) {
            this.toastService.show({
              status: 'warning',
              text: `Erro ao ${message} credito de carbono`
            });
          }

          return this.handleErrorService.handleError(err)
        }
      )
    );
  }
}

export enum ClickTypeEnum {
  APROVAR = 'aprovar',
  REJEITAR = 'rejeitar',
  DETALHES = 'detalhes'
}
